<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      closeable
      round
      title="提示"
      close-icon-position="top-right"
      :style="{ height: '60%' }"
      :close-on-click-overlay="false"
    >
      <div class="my-content">
        <div class="title">提示</div>
        <div class="info">
          <!-- <p>
            1. 您所填写的快递单号<span style="color: #f8a651"
              >不符合当前快递公司的格式</span
            >，请检查单号是否正确
          </p>
          <p>
            2. 请仔细核对<span style="color: #f8a651">发货商品及数量</span>！
          </p> -->
          <p>
            请仔细核对<span style="color: #f8a651">发货商品及数量</span>！
          </p>
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in orderList" :key="index">
            <div class="one">
              <img
                :src="
                  (item.skuImageInfoUrlList? item.skuImageInfoUrlList[0] :item.skuImageKey) +
                  '?x-oss-process=style/style_myorder_list_img'
                "
                alt=""
              />
              <div class="goods-info">
                <p>
                  {{ item.goodsName || item.itemName }}
                </p>
                <div class="sku">
                  <span>数量：{{ item.goodsCount || item.count}}件；</span>
                  <span>{{ item.attributeValues }}</span>
                </div>
                <div class="zen" v-if="item.zpTag">赠品</div>
              </div>
            </div>
            <div class="two">
              <span v-show="item.goodsCode"
                >商品货号：{{ item.goodsCode }}</span
              >
              <span v-show="item.skuCode">规格编码：{{ item.skuCode }}</span>
              <span v-show="item.internationalGoodsCode"
                >国际编码：{{ item.internationalGoodsCode }}</span
              >
              
            </div>
          </div>
        </div>
        <div class="btn-box">
          <div class="cacel-btn" @click="poupClose">取消</div>
          <div class="sure-btn" @click="confirm1">确认无误</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      orderList: [],
    };
  },
  props: {
    orderItem: {
      type: Array,
      default: () => {
        return [];
      },
      required: true,
    },
    zengpin: {
      type: Array,
      default: () => {
        return [];
      },
      required: false,
    },
    isMerge: {
      type: Boolean,
      default: () => {
        return false;
      },
      required: false,
    },
  },
  created() {
    
    this.orderList = [];
    this.orderItem.forEach((item) => {
      if (
        item.appSubOrderItemDetailVoList &&
        item.appSubOrderItemDetailVoList.length > 0
      ) {
        item.appSubOrderItemDetailVoList.map((item1) => {
          this.orderList.push(item1);
        });
      }
    });
    if (this.isMerge) { // 是否合并查看赠品
        this.zengpin.forEach((item) => {
          if (
            item.appSubOrderItemDetailVoList &&
            item.appSubOrderItemDetailVoList.length > 0
          ) {
            item.appSubOrderItemDetailVoList.map((item1) => {
              this.orderList.push({...item1,zpTag:true});
            });
          }
        });
      }
  },
  methods: {
    confirm1() {
      this.isShow = false;
      this.$emit("reconfirm");
    },
    poupShow() {
      this.$nextTick(()=> {
        this.isShow = true;
        this.orderList = [];
      
        this.orderItem.forEach((item) => {
          if (
            item.appSubOrderItemDetailVoList &&
            item.appSubOrderItemDetailVoList.length > 0
          ) {
            item.appSubOrderItemDetailVoList.map((item1) => {
              this.orderList.push(item1);
            });
          }
        });
        if (this.isMerge) { // 是否合并查看赠品
      
          this.zengpin.forEach((item) => {
            if (
              item.appSubOrderItemDetailVoList &&
              item.appSubOrderItemDetailVoList.length > 0
            ) {
              item.appSubOrderItemDetailVoList.map((item1) => {
                this.orderList.push({...item1,zpTag:true});
              });
            }
          });
        }
      })

      
    },
    poupClose() {
      this.isShow = false;
    },
  },
};
</script>
<style scoped lang="less">
.my-content {
  padding: 30px 40px 0;
  //   height: 100%;
  //   position: relative;
}
.title {
  font-size: 32px;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
.info {
  margin-top: 19px;
}
.info > p {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  padding-left: 25px;
  text-indent: -25px;
}
.list {
  margin-top: 21px;
  height: 550px;
  //   background-color: skyblue;
  overflow: auto;

  .item {
    // height: 206px;
    background: #f7f7f7;
    border-radius: 10px;
    margin-bottom: 15px;
    padding: 20px;
    .one {
      display: flex;
      //   justify-content: space-between;
      img {
        width: 100px;
        height: 100px;
      }
      .goods-info {
        margin-left: 10px;
        & > p {
          max-width: 500px;
          margin-bottom: 10px;
          font-size: 26px;
          font-weight: 500;
          color: #333333;
          overflow: hidden; /* 隐藏超出容器的内容 */
          white-space: nowrap; /* 禁止文本换行 */
          text-overflow: ellipsis; /* 超出部分显示为省略号 */
        }
        .sku {
          font-size: 24px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .two {
      font-size: 20px;
      font-weight: 400;
      color: #999999;
      line-height: 30px;
      padding-left: 10px;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      span {
        word-wrap: normal;
      }
    }
  }
}
.btn-box {
  position: absolute;
  width: calc(100% - 80px);
  bottom: 49px;
  display: flex;
  justify-content: space-around;
  .cacel-btn {
    background: #ffffff;
    border-radius: 40px;
    border: 1px solid #999999;
    width: 325px;
    line-height: 80px;
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    color: #999999;
  }
  .sure-btn {
    background: #f8d541;
    border-radius: 40px;
    border: 1px solid #f8d541;
    width: 325px;
    line-height: 80px;
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
  }
}
.zen{
        width: 64px;
        height: 32px;
        background: #E15554;
        border-radius: 4px;
        font-size: 24px;
        color: #FFFFFF;
        font-weight: 400;
        text-align: center;
        line-height: 32px;
        // position:absolute;
        bottom: 0;
      }
</style>